export const args = {
    uri: 'https://www.google.com',
    isOpenInNewTab: false,
};
export const argTypes = {};
